module.exports = __webpack_public_path__ + "static/media/vanja.2054cd9f.jpg";